'use strict';

var buildClassCheckMethods = require('../internal/buildClassCheckMethods');

buildClassCheckMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/build/buildClassCheckMethodsCall.js
// module id = 22
// module chunks = 0